import ResendVerificationCodeRequestModelBase from '../_generated/modelBases/resend-verification-code-request-model-base';

export default class ResendVerificationCodeRequestModel extends ResendVerificationCodeRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
